import React from 'react';

const AnalyticsSkeleton = () => (
  <div className="rounded-2xl bg-primary-200 p-5 animate-pulse">
    <div className="flex justify-between">
      <div className="text-2xl font-semibold h-4 w-40 bg-gray-300 rounded-full" />
    </div>

    <div className="mt-4 bg-white p-5 rounded-2xl">
      <div className="text-base flex items-center font-normal h-3 w-32 bg-gray-300 rounded-full" />
      <div className="mt-6 text-3xl font-semibold h-3 w-10 bg-gray-300 rounded-full" />
    </div>

    <div className="mt-4 flex">
      <div className="w-full bg-white p-5 rounded-2xl mr-2">
        <div className="text-base flex items-center font-normal h-3 w-32 bg-gray-300 rounded-full" />
        <div className="mt-6 text-3xl font-semibold h-3 w-10 bg-gray-300 rounded-full" />
      </div>

      <div className="w-full bg-white p-5 rounded-2xl ml-2">
        <div className="text-base flex items-center font-normal h-3 w-32 bg-gray-300 rounded-full" />
        <div className="mt-6 text-3xl font-semibold h-3 w-10 bg-gray-300 rounded-full" />
      </div>
    </div>
  </div>
);

export default AnalyticsSkeleton;
